import type { Listing } from '@adc/sdk/types'

export const getAiAssistantPDPTargetingContext = (listing: Listing) => ({
  // This defines the shared custom context
  kind: 'ai-assistant-listing-usePage',
  key: listing.listing_id,
  listing_status: listing.listing_status,
  state: listing.seller_property?.country_primary_subdivision,
  event_type: listing.event?.event_type,
  asset_type: listing.listing_configuration?.asset_type,
  product_type: listing.listing_configuration?.product_type,
  trustee_sales_channel: listing.listing_configuration?.trustee_sales_channel,
})
